module.exports = __webpack_public_path__ + "static/template_year_photo-fb95a917ce4e5974f3d343b227a71b24.png";